module.exports = __webpack_public_path__ + "media/landing_page/instacart-logo-cashew-0f920137.svg";